import React from 'react';

const SIZES = { lg: 'sg-tile--lg', md: 'sg-tile--md', sm: 'sg-tile--sm', xs: 'sg-tile--xs' };

// A single chunky letter tile. Size is a token: lg | md | sm | xs.
const LetterTile = ({ letter, size = 'md', className = '', style }) => (
    <div className={`sg-tile ${SIZES[size] || SIZES.md} ${className}`} style={style}>
        {letter}
    </div>
);

export default LetterTile;
